/**
 * AppShell — Main layout wrapper with sidebar + topbar + content area.
 */

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main area */}
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* Topbar */}
        <Topbar onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />

        {/* Content */}
        <main className="flex-1 overflow-y-auto p-page-padding lg:p-page-padding-lg">
          <div className="max-w-content mx-auto">
            <Outlet />
          </div>
          {/* Global copyright footer — shown on every authenticated page */}
          <footer className="max-w-content mx-auto mt-10 pt-6 border-t text-center"
                  style={{ borderColor: 'var(--color-card-border)' }}>
            <p className="text-[14px]" style={{ color: 'var(--color-text-muted)' }}>
              © {new Date().getFullYear()} AtalCloud. All rights reserved.
            </p>
          </footer>
        </main>
      </div>
    </div>
  );
}
